<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <div class="flex-grow">
          <vs-button
            color="primary"
            type="gradient"
            class="mb-4 md:mb-0"
            @click="add"
            >Add New Data</vs-button
          >
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ page * per_page - (per_page - 1) }} -
              {{
                row_total - page * per_page > 0 ? page * per_page : row_total
              }}
              of {{ row_total }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <vs-dropdown-menu>
            <vs-dropdown-item @click="updatePerPage(10)">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(25)">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(50)">
              <span>50</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="updatePerPage(100)">
              <span>100</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>

        <vs-input
          class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="keyword"
          @keyup="search"
          placeholder="Search..."
        />
      </div>
      <div class="table-container">
        <table class="table">
          <thead>
            <tr>
              <th>No</th>
              <th v-if="actor.privilege <= 3">Owner</th>
              <th>Imei</th>
              <th>Plate</th>
              <th>GSM No</th>
              <th>Master Name</th>
              <th>URL Endpoint</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody v-if="loading">
            <tr>
              <td colspan="8" class="text-center">Loading....</td>
            </tr>
          </tbody>
          <tbody v-else-if="data.length > 0">
            <tr v-for="(item, index) in data" :key="index">
              <td>{{ (page - 1) * per_page + (index + 1) }}</td>
              <td v-if="actor.privilege <= 3">{{ item.owner }}</td>
              <td>{{ item.imei }}</td>
              <td>{{ item.plate }}</td>
              <td>{{ item.gsm_no }}</td>
              <td>{{ item._project_master.project_name }}</td>
              <td>{{ item._project_master.url_endpoint }}</td>
              <td style="width: 90px">
                <div v-if="item.id !== 0" class="flex">
                  <vx-tooltip text="Edit" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-edit"
                      color="success"
                      class="mr-2"
                      @click="edit(index)"
                    ></vs-button>
                  </vx-tooltip>
                  <vx-tooltip text="Delete" position="top">
                    <vs-button
                      type="border"
                      size="small"
                      icon-pack="feather"
                      icon="icon-trash"
                      color="danger"
                      @click="del(item.id)"
                    ></vs-button>
                  </vx-tooltip>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="8" class="text-center">No Data Available</td>
            </tr>
          </tbody>
        </table>

        <vs-pagination :total="n_page" v-model="page"></vs-pagination>
      </div>

      <vs-popup
        class="vs-popup-lg"
        classContent="popup-example"
        :title="popupTitle"
        :active.sync="showPopup"
      >
        <template>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/2 w-full">
              <label class="text-sm opacity-75">URL Enpoint</label>
              <v-select
                @search="searchUrlEndpoint"
                :options="UrlEndpoint"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="input.id_master"
              />
            </div>
            <div v-if="action == 'edit'" class="vx-col sm:w-1/2 w-full">
              <vs-input
                disabled
                label="Imei"
                class="w-full"
                type="text"
                v-model="input.imei_edit"
              />
            </div>
            <div
              v-if="action == 'edit' && actor.privilege <= 3"
              class="vx-col sm:w-1/2 w-full"
            >
              <vs-input
                label="Username"
                class="w-full"
                type="text"
                v-model="input.username"
              />
            </div>
            <div
              v-if="action == 'edit' && actor.privilege <= 3"
              class="vx-col sm:w-1/2 w-full"
            >
              <vs-input
                label="Password"
                class="w-full"
                type="text"
                v-model="input.password"
              />
            </div>
            <div
              v-if="action == 'edit' && actor.privilege <= 3"
              class="vx-col sm:w-1/2 w-full"
            >
              <vs-input
                label="Status"
                class="w-full"
                type="text"
                v-model="input.status"
              />
            </div>
            <div
              class="vx-col sm:w-1/2 w-full"
              v-if="actor.privilege <= 3 && action == 'add'"
            >
              <label class="text-sm opacity-75">Owner (Username)</label>
              <v-select
                @search="searchOwner"
                :options="ownerFilterList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="filter.owner"
              />
            </div>
          </div>

          <hr v-if="action == 'add'" />

          <div v-if="action == 'add'" class="vx-card p-6">
            <div class="vx-row">
              <div class="vx-col md:w-1/2">
                <vs-dropdown vs-trigger-click class="cursor-pointer mr-2">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
                  >
                    <span class="mr-2"
                      >{{ page_gps * per_page_gps - (per_page_gps - 1) }} -
                      {{
                        row_total_gps - page_gps * per_page_gps > 0
                          ? page_gps * per_page_gps
                          : row_total_gps
                      }}
                      of {{ row_total_gps }}</span
                    >
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="updatePerPage_gps(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage_gps(25)">
                      <span>25</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage_gps(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="updatePerPage_gps(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>

              <div class="vx-col md:w-1/2">
                <vs-input
                  class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
                  v-model="keyword_gps"
                  @keyup="search_gps"
                  placeholder="Search..."
                />
              </div>
            </div>

            <div class="table-container">
              <table class="table">
                <thead>
                  <tr>
                    <th>No</th>
                    <th>Owner</th>
                    <th>Imei</th>
                    <th>Plate</th>
                    <th>GSM No</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody v-if="loading_gps">
                  <tr>
                    <td colspan="6" class="text-center">Loading....</td>
                  </tr>
                </tbody>
                <tbody v-else-if="data_gps.length > 0">
                  <tr v-for="(item, index) in data_gps" :key="index">
                    <td>{{ (page_gps - 1) * per_page_gps + (index + 1) }}</td>
                    <td>{{ item.username }}</td>
                    <td>{{ item.imei }}</td>
                    <td>{{ item.plate }}</td>
                    <td>{{ item.gsm_no }}</td>
                    <td style="width: 90px">
                      <div v-if="item.id !== 0" class="flex">
                        <vs-checkbox
                          v-if="item.status === false"
                          v-model="list_imei"
                          :vs-value="item.imei"
                        >
                        </vs-checkbox>
                        <span v-else style="color: green; font-weight: 500"
                          >Assigned</span
                        >
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="6" class="text-center">No Data Available</td>
                  </tr>
                </tbody>
              </table>

              <vs-pagination
                :total="n_page_gps"
                v-model="page_gps"
              ></vs-pagination>
            </div>
          </div>

          <div class="vx-row">
            <div class="vx-col w-full ml-auto">
              <vs-button
                id="submitBtn"
                class="mr-3 mb-2 vs-con-loading__container"
                @click="submit"
                >Submit</vs-button
              >
              <vs-button
                v-show="action === 'add'"
                color="warning"
                type="border"
                @click="reset"
                class="mb-2"
                >Reset</vs-button
              >
            </div>
          </div>
        </template>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },

  data() {
    return {
      actor: {},
      data: [],
      data_all: [],
      token: '',
      showPopup: false,
      popupTitle: '',
      action: '',
      loading: true,
      loading_gps: true,

      tempId: 0,
      input: {
        owner: '',
        id_master: '',
        imei_edit: '',
        username: '',
        password: '',
        status: ''
      },

      list_imei: [],

      page: 1,
      per_page: 10,
      row_total: 0,
      keyword: '',

      data_gps: [],
      page_gps: 1,
      per_page_gps: 10,
      row_total_gps: 0,
      keyword_gps: '',

      ownerFilterList: [],
      UrlEndpoint: [],

      filter: {
        owner: ''
      },

      selected_assigned: '',

      timer: null,
      timer_gps: null,
      notify: 'Server Error'
    }
  },

  computed: {
    n_page() {
      return Math.ceil(this.row_total / this.per_page)
    },
    n_page_gps() {
      return Math.ceil(this.row_total_gps / this.per_page_gps)
    },
    filterOwner() {
      return this.filter.owner ? this.filter.owner.value : ''
    }
  },

  watch: {
    page() {
      this.initTable()
    },

    per_page() {
      if (this.page != 1) this.page = 1
      else this.initTable()
    },

    page_gps() {
      this.dataGps()
    },

    per_page_gps() {
      if (this.page_gps != 1) this.page_gps = 1
      else this.dataGps()
    },

    filter: {
      handler(val) {
        this.page_gps = 1
        // this.dataGps()
      },
      deep: true
    },

    list_imei: {
      handler(val) {
        // console.log(val)
      },
      deep: true
    },

    filterOwner() {
      this.dataGps()
    }
  },

  created() {
    this.token =
      localStorage.getItem('userInfo') !== null
        ? JSON.parse(localStorage.getItem('userInfo')).token
        : ''
    this.$http
      .get(`${this.$api.endpoint}/user/profile`, {
        headers: {
          Authorization: `Bearer ${this.token}`
        }
      })
      .then((res) => {
        this.actor = res.data.message.data
        this.initTable()
        this.allDataAssigne()
      })
      .catch((error) => {
        this.$gf.httpErrorHandler(error)
      })
  },

  mounted() {},

  methods: {
    search() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.page = 1
        this.initTable()
      }, 800)
    },

    search_gps() {
      if (this.timer_gps) {
        clearTimeout(this.timer_gps)
        this.timer_gps = null
      }
      this.timer_gps = setTimeout(() => {
        this.page_gps = 1
        this.dataGps()
      }, 800)
    },

    updatePerPage(n) {
      this.per_page = n
      this.initTable()
    },

    updatePerPage_gps(n) {
      this.per_page_gps = n
      this.dataGps()
    },

    reset() {
      Object.keys(this.input).map((item) => {
        this.input[item] = ''
      })
    },

    dataGps() {
      this.loading_gps = true
      this.$http
        .get(`${this.$api.endpoint}/project_assignment/data_gps`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            page: this.page_gps,
            per_page: this.per_page_gps,
            search: this.keyword_gps,
            owner: this.filter.owner ? this.filter.owner.value : ''
          }
        })
        .then((res) => {
          this.row_total_gps = res.data.message.total
          var temp = res.data.message.data
          this.data_gps = []

          temp.map((item, index) => {
            var status = this.selectAssignment(item.imei)
            let tempStatus = {
              status: status
            }

            let data = {
              ...temp[index],
              ...tempStatus
            }

            this.data_gps.push(data)
          })

          this.loading_gps = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    initTable() {
      this.loading = true
      this.$http
        .get(
          `${this.$api.endpoint}/project_assignment/datatable?page=${this.page}&per_page=${this.per_page}&search=${this.keyword}`,
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.row_total = res.data.message.total
          this.data = res.data.message.data
          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    allDataAssigne() {
      this.loading = true
      this.$http
        .get(`${this.$api.endpoint}/project_assignment/all`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.data_all = []
          var data = res.data.message.data
          data.map((item) => {
            this.data_all.push(item.imei)
          })

          this.loading = false
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    searchOwner(search) {
      if (search.length >= 3) {
        this.$http
          .get(`${this.$api.endpoint}/project_assignment/owner`, {
            headers: {
              Authorization: `Bearer ${this.token}`
            },
            params: {
              // branch: this.actor.branch,
              search: search
            }
          })
          .then((res) => {
            this.ownerFilterList = res.data.message.data
          })
          .catch((error) => {
            this.$gf.httpErrorHandler(error)
          })
      } else {
        this.ownerFilterList = []
      }
    },

    searchUrlEndpoint(search) {
      this.$http
        .get(`${this.$api.endpoint}/project_master/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          },
          params: {
            search: search
          }
        })
        .then((res) => {
          this.UrlEndpoint = res.data.message.data
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    gethUrlEndpoint(id_master) {
      this.$http
        .get(`${this.$api.endpoint}/project_master/select`, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.UrlEndpoint = res.data.message.data
          if (id_master) {
            this.input.id_master = this.UrlEndpoint.find((item) => {
              return item.value === id_master
            })
          }
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    selectAssignment(imei) {
      return this.data_all.includes(imei)
    },

    add() {
      if (this.action === 'edit') this.reset()
      this.action = 'add'
      this.popupTitle = 'Add Project Assign'

      this.ownerFilterList = []
      this.list_imei = []

      this.dataGps()
      this.searchUrlEndpoint('')

      this.showPopup = true
    },

    edit(index) {
      this.action = 'edit'
      this.popupTitle = 'Edit Project Assign'

      const data = this.data[index]

      this.tempId = data.id
      this.input.imei_edit = data.imei
      this.input.username = data.username
      this.input.password = data.password
      this.input.status = data.status

      this.gethUrlEndpoint(data.id_master)

      this.showPopup = true
    },

    del(id) {
      this.tempId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Delete Project Assign`,
        text: 'Are you sure want to Delete this data ?',
        accept: this.confirmDelete
      })
    },

    confirmDelete() {
      this.$http
        .post(
          `${this.$api.endpoint}/project_assignment/delete/${this.tempId}`,
          {},
          {
            headers: {
              Authorization: `Bearer ${this.token}`
            }
          }
        )
        .then((res) => {
          this.notify = res.data.message.split('_').join(' ')

          this.initTable()
          this.allDataAssigne()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$gf.httpErrorHandler(error)
        })
    },

    submit() {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: '#submitBtn',
        scale: 0.45
      })

      let url =
        this.action === 'add'
          ? `${this.$api.endpoint}/project_assignment/add`
          : `${this.$api.endpoint}/project_assignment/update/${this.tempId}`

      let form_data =
        this.action === 'add'
          ? {
              url_endpoint: this.input.id_master.value,
              owner:
                this.actor.privilege <= 3
                  ? this.filter.owner.value
                  : this.actor.id,
              imei: this.list_imei
            }
          : {
              url_endpoint: this.input.id_master.value,
              username: this.input.username,
              password: this.input.password,
              status: this.input.status
            }

      this.$http
        .post(url, form_data, {
          headers: {
            Authorization: `Bearer ${this.token}`
          }
        })
        .then((res) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')

          this.notify = res.data.message.split('_').join(' ')

          this.showPopup = false
          this.initTable()
          this.allDataAssigne()
          this.dataGps()
          this.reset()

          this.$vs.notify({
            title: 'Thank You',
            text: this.notify,
            color: 'success',
            position: 'top-right'
          })
        })
        .catch((error) => {
          this.$vs.loading.close('#submitBtn > .con-vs-loading')
          this.$gf.httpErrorHandler(error)
        })
    }
  }
}
</script>
